import { Box, Button, Link, Typography, useMediaQuery } from '@mui/material';
import { APP_URLS } from '../App.constants';

function Footer({ setContactUsOpened }: { setContactUsOpened: (s: boolean) => void }) {
  const isMobile = useMediaQuery('(max-width:800px)');

  return (
    <Box
      id="footer_anchor"
      sx={{
        // backgroundImage: 'url(/images/pattern.svg)',
        backgroundPosition: 'center',
      }}
    >
      <Box
        sx={{
          maxWidth: '1350px',
          margin: 'auto',
          padding: isMobile ? '80px 20px' : '80px 20px 80px',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          gap: '80px',
          borderTop: '1px solid #2E2E2E',
        }}
      >
        <Box
          sx={{
            background: '#247BFE',
            borderRadius: isMobile ? '24px' : '32px',
            overflow: 'hidden',
            display: 'flex',
            gap: '20px',
            justifyContent: 'space-between',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              minWidth: isMobile ? undefined : '600px',
              maxWidth: '100%',
              margin: isMobile ? '40px 20px 0' : '0 0 0 50px',
            }}
          >
            <Typography
              sx={{
                fontSize: isMobile ? '20px' : '56px',
                fontFamily: 'RedHat700',
                color: '#FFF',
                marginBottom: isMobile ? '10px' : '20px',
                lineHeight: 'normal',
              }}
            >
              Ready to get started?
              <br />
              Contact us today
            </Typography>
            <Typography
              sx={{
                fontSize: isMobile ? '16px' : '20px',
                fontFamily: 'RedHat400',
                color: '#FFF',
                lineHeight: isMobile ? 'normal' : '30px',
              }}
            >
              Get in touch with our team to learn more about our platform and how it can transform your data management
              and marketing strategies. We’re here to help you succeed!
            </Typography>
            <Button
              onClick={() => {
                setContactUsOpened(true);
              }}
              variant="contained"
              sx={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                padding: isMobile ? '15px 30px' : '20px 40px',
                fontSize: isMobile ? '16px' : '20px',
                fontFamily: 'RedHat800',
                color: '#247BFE',
                marginTop: isMobile ? '20px' : '30px',
                textTransform: 'initial',
                boxShadow: 'none',
              }}
            >
              Contact us
            </Button>
          </Box>
          <img
            style={{
              maxWidth: '100%',
            }}
            width={isMobile ? '100%' : 460}
            src={isMobile ? '/images/contact_mob.webp' : '/images/contact.webp'}
            alt="contact"
          ></img>
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: isMobile ? 'center' : undefined,
            }}
          >
            <img width={130} src="/images/logo_new.svg" alt="logo"></img>
            <Typography
              sx={{
                fontSize: '14px',
                fontFamily: 'RedHat400',
                color: '#B5B5B5',
                marginTop: '30px',
                lineHeight: 'normal',
                textAlign: isMobile ? 'center' : undefined,
              }}
            >
              APPHITMINCHAN LIMITED. HE427515.
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                fontFamily: 'RedHat400',
                color: '#B5B5B5',
                marginTop: '10px',
                lineHeight: 'normal',
                textAlign: isMobile ? 'center' : undefined,
              }}
            >
              Arch. Makariou III, 195 NEOCLEOUS HOUSE 3030 Limassol Cyprus
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: isMobile ? 'center' : undefined,
            }}
          >
            <Link
              style={{
                fontSize: '24px',
                fontFamily: 'RedHat700',
                color: '#fff',
                lineHeight: 'normal',
                textDecorationColor: '#fff',
                textAlign: 'right',
                marginTop: isMobile ? '30px' : undefined,
              }}
              href={`mailto:${APP_URLS.SUPPORT}`}
            >
              {APP_URLS.SUPPORT}
            </Link>

            <Typography
              onClick={() => {
                window.open('/privacy.html', '_blank');
              }}
              style={{
                fontSize: '14px',
                fontFamily: 'RedHat400',
                color: '#B5B5B5',
                textAlign: 'right',
                lineHeight: 'normal',
                textDecoration: 'underline',
                marginTop: isMobile ? '30px' : '34px',
                cursor: 'pointer',
              }}
            >
              Privacy Policy
            </Typography>

            <Typography
              onClick={() => {
                window.open('/terms.html', '_blank');
              }}
              style={{
                fontSize: '14px',
                fontFamily: 'RedHat400',
                color: '#B5B5B5',
                textAlign: 'right',
                lineHeight: 'normal',
                textDecoration: 'underline',
                cursor: 'pointer',
                marginTop: isMobile ? '20px' : '10px',
              }}
            >
              Terms and Conditions
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Footer;
